import { useState } from 'react' 
import './styles/Contribute.css'

const Contribute = () => {
    const [hiddenClass, setHiddenClass] = useState('')

    setTimeout(() => {
        setHiddenClass("hide-button")
    }, 2000)

    return (
        <div>
        </div>
    )
}

export default Contribute